import { FC } from 'react';
import classes from './Login.module.scss';
import LoginForm from 'views/login/loginForm/LoginForm';

const Login: FC = () => {
    return (
        <div className={classes.container}>
            <div className={classes.loginForm}>
                <LoginForm />
            </div>
        </div>
    );
};

export default Login;
